(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asavya-all-reviews"]) return;
  try {
    
(function(){
  function stars(n){return '★★★★★☆☆☆☆☆'.slice(5-n,10-n);}
  function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
  document.addEventListener('DOMContentLoaded',function(){
    var el=document.getElementById('asv-reviews-json');
    var data=[];try{data=JSON.parse(el.textContent)}catch(e){return}
    var total=data.length;
    var avg=(data.reduce(function(a,r){return a+r.rating},0)/total);
    var sec=document.getElementById('reviews');
    var avgEl=sec.querySelector('[data-ar-avg]');if(avgEl)avgEl.textContent=avg.toFixed(1).replace('.',',');
    sec.querySelectorAll('[data-ar-total]').forEach(function(e){e.textContent=total});
    var restEl=sec.querySelector('[data-ar-rest]');if(restEl)restEl.textContent=Math.max(0,total-5);

    // distribution bars
    var bars=document.getElementById('asv-ar-bars');
    if(bars){
      var bh='';
      [5,4,3,2,1].forEach(function(s){
        var c=data.filter(function(r){return r.rating===s}).length;
        var pct=total?(c/total*100):0;
        bh+='<div class="asv-ar__bar"><span class="asv-ar__bar-num">'+s+'</span><span class="asv-ar__bar-star">★</span>'+
            '<span class="asv-ar__bar-track"><span class="asv-ar__bar-fill" style="width:'+pct+'%"></span></span>'+
            '<span class="asv-ar__bar-count">'+c+'</span></div>';
      });
      bars.innerHTML=bh;
    }

    // review cards
    var list=document.getElementById('asv-ar-list');
    if(!list)return; /* Loox mode: built-in list absent */
    var more=document.getElementById('asv-ar-more');
    function card(r){
      var av=r.image?'<img class="asv-ar__rev-av" src="'+r.image+'" alt="'+esc(r.name)+'">':'<div class="asv-ar__rev-av" style="background:var(--card);display:flex;align-items:center;justify-content:center;font-weight:600;color:var(--muted-fg)">'+esc(r.name.charAt(0))+'</div>';
      var img=r.image?'<img class="asv-ar__rev-img" src="'+r.image+'" alt="Photo de l\'avis" loading="lazy">':'';
      var date=r.date?'<span class="asv-ar__rev-date">'+esc(r.date)+'</span>':'';
      return '<div class="asv-ar__rev"><div class="asv-ar__rev-head"><div class="asv-ar__rev-id">'+av+
        '<div><div class="asv-ar__rev-name">'+esc(r.name)+' 🇫🇷</div><div class="asv-ar__rev-verif"><span>✓</span>Acheteur vérifié</div></div></div>'+date+'</div>'+
        '<div class="asv-ar__rev-stars">'+stars(r.rating)+'</div>'+img+
        '<p class="asv-ar__rev-text">'+esc(r.text)+'</p></div>';
    }
    function render(items){list.innerHTML=items.map(card).join('');}
    render(data.slice(0,5));
    if(more){
      more.addEventListener('click',function(){render(data);more.hidden=true;});
      if(total<=5)more.hidden=true;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-announcement"]) return;
  try {
    
(function(){
  /* la durée dépend de la largeur réelle : vitesse constante, sans à-coup */
  function init(bar){
    var track=bar.querySelector('[data-asv-ann-track]');
    var group=bar.querySelector('[data-asv-ann-group]');
    if(!track||!group)return;
    var speed=parseFloat(bar.style.getPropertyValue('--asv-ann-speed'))||40;
    function sync(){
      var w=group.getBoundingClientRect().width;
      if(!w)return;
      track.style.setProperty('--asv-ann-dur',(w/speed).toFixed(2)+'s');
    }
    sync();
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(sync);
    window.addEventListener('resize',sync);
  }
  function scan(){document.querySelectorAll('.asv-ann').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.asv-offer').forEach(function(root){
    var packs = root.querySelectorAll('[data-asv-pack]');
    var qtyInput = root.querySelector('[data-asv-qty]');
    var priceNow = root.querySelector('[data-asv-price]');
    var priceWas = root.querySelector('[data-asv-was]');
    var pricePill = root.querySelector('[data-asv-pill]');
    var atcNow = root.querySelector('[data-asv-atc-now]');
    var atcWas = root.querySelector('[data-asv-atc-was]');

    function select(pack){
      packs.forEach(function(p){
        p.classList.remove('is-selected');
        var r = p.querySelector('input[type=radio]');
        if(r) r.checked = false;
      });
      pack.classList.add('is-selected');
      var radio = pack.querySelector('input[type=radio]');
      if(radio) radio.checked = true;

      var qty = pack.getAttribute('data-qty');
      var price = pack.getAttribute('data-price');
      var was = pack.getAttribute('data-was');
      var pill = pack.getAttribute('data-pill');

      if(qtyInput) qtyInput.value = qty;
      if(priceNow) priceNow.textContent = price;
      if(priceWas) priceWas.textContent = was;
      if(pricePill && pill) pricePill.textContent = pill;
      if(atcNow) atcNow.textContent = price;
      if(atcWas) atcWas.textContent = was;
    }

    packs.forEach(function(pack){
      pack.addEventListener('click', function(){ select(pack); });
      pack.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); select(pack); }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-countdown"]) return;
  try {
    
(function(){
  function pad(n){return String(n).padStart(2,'0');}
  /* Tolerant : accepte "2026-09-30", "2026-09-30 23:59" ou "2026-09-30T23:59:59".
     Sans heure, on prend la fin de journee. */
  function parseEnd(v){
    if(!v)return NaN;
    v=String(v).trim().replace(' ','T');
    if(/^\d{4}-\d{2}-\d{2}$/.test(v))v+='T23:59:59';
    else if(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(v))v+=':00';
    return new Date(v).getTime();
  }
  function tick(){
    var t=document.getElementById('asv-timer');
    if(!t)return;
    var end=parseEnd(t.getAttribute('data-end'));   /* relu a chaque tick : mise a jour live dans l'editeur */
    var dEl=document.getElementById('asv-d'),hEl=document.getElementById('asv-h'),mEl=document.getElementById('asv-m');
    if(isNaN(end)){if(dEl)dEl.textContent='00';if(hEl)hEl.textContent='00';if(mEl)mEl.textContent='00';return;}
    var diff=end-Date.now();if(diff<0)diff=0;
    var d=Math.floor(diff/86400000),h=Math.floor(diff%86400000/3600000),m=Math.floor(diff%3600000/60000);
    if(dEl)dEl.textContent=pad(d);if(hEl)hEl.textContent=pad(h);if(mEl)mEl.textContent=pad(m);
  }
  tick();
  if(!window.__asvCdInt){window.__asvCdInt=setInterval(tick,1000);}
  document.addEventListener('shopify:section:load',tick);   /* re-rendu dans l'editeur */
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.asv-faq [data-faq]').forEach(function(btn){
  btn.addEventListener('click',function(){
    var a=btn.nextElementSibling;var open=!a.hidden;a.hidden=open;btn.classList.toggle('open',!open);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-header"]) return;
  try {
    
(function(){
  var hdr=document.getElementById('asv-hdr');
  var spacer=document.getElementById('asv-hdr-spacer');
  var ann=document.querySelector('.asv-ann');
  var last=window.scrollY||0;
  function layout(){ if(spacer&&hdr){spacer.style.height=hdr.offsetHeight+'px';} }
  function tick(y){
    if(ann&&hdr){var b=ann.getBoundingClientRect().bottom;hdr.style.top=(b>0?b:0)+'px';hdr.classList.toggle('stuck',b<=0);}
    if(y<=10){hdr.classList.remove('hide');}
    else if(y>last){hdr.classList.add('hide');}
    else if(y<last){hdr.classList.remove('hide');}
    last=y;
  }
  window.__hdrTick=tick;
  layout();tick(window.scrollY);
  window.addEventListener('scroll',function(){tick(window.scrollY);},{passive:true});
  window.addEventListener('resize',layout);
  window.addEventListener('load',layout);
  var overlay=document.getElementById('asv-overlay');
  document.getElementById('asv-menu-btn').addEventListener('click',function(){overlay.classList.add('open')});
  document.getElementById('asv-close-btn').addEventListener('click',function(){overlay.classList.remove('open')});
  overlay.addEventListener('click',function(e){if(e.target===overlay)overlay.classList.remove('open')});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-home-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-hh-cta]').forEach(function(btn){
    btn.addEventListener('click',function(){
      /* on vise en priorite la vraie fiche produit si elle est presente sur la page */
      var t=document.querySelector('.asv-hero')||document.querySelector('.asv-fo')||document.getElementById('home-bundle');
      if(t)t.scrollIntoView({behavior:'smooth'});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-product-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var track=document.getElementById('asv-gal-track');
  if(track){
    var slides=track.querySelectorAll('.asv-gal__slide');
    var dots=document.querySelectorAll('#asv-gal .asv-gal__dot');
    var cur=document.getElementById('asv-gal-cur');
    var idx=0;
    var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* On precharge la video du slide courant et de ses voisins : quand le client
       arrive dessus, elle est deja bufferisee et demarre sans attente. */
    function warm(i){
      [i-1,i,i+1].forEach(function(n){
        var sl=slides[(n+slides.length)%slides.length];
        if(!sl)return;
        var v=sl.querySelector('video');
        if(v&&v.preload!=='auto'){v.preload='auto';v.load();}
      });
    }
    /* Lecture auto muette sur le slide actif, pause sur tous les autres. */
    function syncVideo(active){
      slides.forEach(function(sl,i){
        var v=sl.querySelector('video');
        if(!v)return;
        if(i===active){
          if(reduceMotion)return;
          v.muted=true;
          var p=v.play();
          if(p&&p.catch)p.catch(function(){});
        }else if(!v.paused){v.pause();}
      });
    }
    function pauseOthers(active){warm(active);syncVideo(active);}
    function goTo(n){
      if(!slides.length)return;
      idx=(n+slides.length)%slides.length;
      track.scrollTo({left:idx*track.offsetWidth,behavior:'smooth'});
      dots.forEach(function(d,i){d.classList.toggle('is-on',i===idx)});
      if(cur)cur.textContent=idx+1;
      pauseOthers(idx);
    }
    var pBtn=document.getElementById('asv-gal-p'),nBtn=document.getElementById('asv-gal-n');
    if(pBtn)pBtn.addEventListener('click',function(){goTo(idx-1)});
    if(nBtn)nBtn.addEventListener('click',function(){goTo(idx+1)});
    dots.forEach(function(d){d.addEventListener('click',function(){goTo(parseInt(d.dataset.idx))})});
    pauseOthers(0);
    var ticking=false;
    track.addEventListener('scroll',function(){
      if(!ticking){requestAnimationFrame(function(){
        var i=Math.round(track.scrollLeft/track.offsetWidth);
        if(i!==idx){idx=i;dots.forEach(function(d,j){d.classList.toggle('is-on',j===i)});if(cur)cur.textContent=i+1;pauseOthers(i)}
        ticking=false;
      });ticking=true}
    },{passive:true});
  }
  // Accordion (delegated, idempotent)
  if(!window.__asvAccInit){
    window.__asvAccInit=true;
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-acc]');
      if(!btn)return;
      var panel=btn.nextElementSibling;
      if(!panel)return;
      var open=!panel.hidden;
      panel.hidden=open;
      btn.classList.toggle('is-open',!open);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-reasons"]) return;
  try {
    
(function(){
  var track=document.getElementById('asv-rs-track');
  var dots=document.querySelectorAll('#asv-rs-dots .asv-rs__dot');
  if(!track||!dots.length)return;
  dots.forEach(function(d){d.addEventListener('click',function(){
    var slide=track.children[parseInt(d.dataset.idx)];
    if(slide)track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:'smooth'});
  })});
  var ticking=false;
  track.addEventListener('scroll',function(){
    if(!ticking){requestAnimationFrame(function(){
      var sw=track.children[0]?track.children[0].offsetWidth:1;
      var i=Math.round(track.scrollLeft/sw);
      dots.forEach(function(d,j){d.classList.toggle('is-on',j===i)});
      ticking=false;
    });ticking=true}
  },{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function thumb(u){return (u&&u.indexOf('cdn.shopify.com')>-1)?u+(u.indexOf('?')>-1?'&':'?')+'width=280':u;}
  function init(){
    var strip=document.getElementById('asv-ur-strip');
    if(!strip)return;
    var el=document.getElementById('asv-reviews-json');
    var data=[];try{data=JSON.parse(el.textContent)}catch(e){return}
    var photos=data.slice(0,30).filter(function(r){return r.image});
    if(!photos.length)return;
    var html='';
    photos.concat(photos).forEach(function(r){
      html+='<img src="'+thumb(r.image)+'" alt="" width="140" height="140" decoding="async" fetchpriority="low">';
    });
    strip.innerHTML=html;
  }
  function car(){
    var sec=document.querySelector('[data-asv-urcar]');
    if(!sec||sec.__asvCar)return; sec.__asvCar=true;
    var track=sec.querySelector('[data-asv-urcar-track]'),dots=sec.querySelector('[data-asv-urcar-dots]');
    if(!track||!dots)return;
    var slides=Array.prototype.slice.call(track.children);
    if(slides.length<2)return;
    dots.innerHTML=slides.map(function(_,i){return '<button type="button" class="asv-ur__dot'+(i?'':' is-on')+'" data-i="'+i+'" aria-label="Avis '+(i+1)+'"></button>';}).join('');
    var btns=Array.prototype.slice.call(dots.children);
    btns.forEach(function(b){b.addEventListener('click',function(){var s=slides[parseInt(b.dataset.i,10)];track.scrollTo({left:s.offsetLeft-track.offsetLeft,behavior:'smooth'});});});
    var ticking=false;
    track.addEventListener('scroll',function(){
      if(ticking)return; ticking=true;
      requestAnimationFrame(function(){
        var mid=track.scrollLeft+track.clientWidth/2,active=0,best=Infinity;
        slides.forEach(function(s,i){var c=s.offsetLeft-track.offsetLeft+s.offsetWidth/2,d=Math.abs(c-mid);if(d<best){best=d;active=i;}});
        btns.forEach(function(b,i){b.classList.toggle('is-on',i===active);});
        ticking=false;
      });
    });
  }
  /* La bande des photos d'avis est entierement construite en JavaScript. On ne la
     construit plus au chargement de la page mais 800 px avant qu'elle arrive a
     l'ecran : elle est donc complete et deja en mouvement quand on la voit, sans
     carre vide qui se remplit. Les 60 photos ne sont plus telechargees par les
     visiteurs qui ne descendent pas jusque-la. */
  function initQuandProche(){
    var strip=document.getElementById('asv-ur-strip');
    if(!strip||strip.__asvPrevu)return; strip.__asvPrevu=true;
    if(!('IntersectionObserver' in window)){init();return;}
    var io=new IntersectionObserver(function(e){
      if(e[0].isIntersecting){io.disconnect();init();}
    },{rootMargin:'800px 0px'});
    io.observe(strip);
  }
  function boot(){initQuandProche();car();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-safety-faq"]) return;
  try {
    
(function(){
  document.querySelectorAll('.asv-sf [data-sf]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.asv-sf__item');
      var panel=btn.nextElementSibling;
      var open=item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.asv-sf__item').forEach(function(it){
        it.classList.remove('is-open');
        var p=it.querySelector('.asv-sf__a');if(p)p.hidden=true;
      });
      if(!open){item.classList.add('is-open');panel.hidden=false;}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sticky=document.getElementById('asv-sticky');
  if(!sticky||!('IntersectionObserver' in window))return;
  var heroBtn=document.querySelector('.asv-hero .asv-cta');
  var endBtn=document.querySelector('.asv-reas__btn');
  /* 'above' = le bouton du hero est passé au-dessus de l'écran */
  var above=false,endVisible=false;
  function update(){
    var show=above&&!endVisible;
    sticky.classList.toggle('visible',show);
    sticky.setAttribute('aria-hidden',String(!show));
  }
  if(heroBtn){
    new IntersectionObserver(function(e){
      var r=e[0].boundingClientRect;
      above=!e[0].isIntersecting&&r.bottom<=0;
      update();
    },{threshold:0}).observe(heroBtn);
    /* filet de sécurité si l'observateur ne s'est pas encore déclenché */
    window.addEventListener('scroll',function(){
      var r=heroBtn.getBoundingClientRect();
      var nowAbove=r.bottom<=0;
      if(nowAbove!==above){above=nowAbove;update();}
    },{passive:true});
  }
  if(endBtn){
    new IntersectionObserver(function(e){endVisible=e[0].isIntersecting;update();},{threshold:0}).observe(endBtn);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asavya-video"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    document.querySelectorAll('.asv-use__video').forEach(function(v){
      if(v.__asvReady)return; v.__asvReady=true;
      if(reduce){v.setAttribute('controls','');v.pause();return;}
      v.muted=true;
      if(!('IntersectionObserver' in window)){var p=v.play();if(p&&p.catch)p.catch(function(){});return;}
      /* La video ne se telecharge plus des l'ouverture de la page (preload="none").
         On la prepare 800 px avant qu'elle n'arrive a l'ecran : elle est donc prete
         au moment ou on la voit, exactement comme avant, mais sans ralentir le reste. */
      var pre=new IntersectionObserver(function(e){
        if(e[0].isIntersecting){v.preload='auto';v.load();pre.disconnect();}
      },{rootMargin:'800px 0px'});
      pre.observe(v);
      new IntersectionObserver(function(e){
        if(e[0].isIntersecting){var pr=v.play();if(pr&&pr.catch)pr.catch(function(){});}
        else if(!v.paused){v.pause();}
      },{threshold:.4}).observe(v);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["asv-problem"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(sec){
    if(sec.__asvCar)return; sec.__asvCar=true;
    var track=sec.querySelector('[data-asv-car-track]');
    var dots=sec.querySelector('[data-asv-car-dots]');
    if(!track||!dots)return;
    var slides=Array.prototype.slice.call(track.children);
    if(slides.length<2)return;
    dots.innerHTML=slides.map(function(_,i){
      return '<button type="button" class="asv-pb__dot'+(i?'':' is-on')+'" data-i="'+i+'" aria-label="Carte '+(i+1)+'"></button>';
    }).join('');
    var btns=Array.prototype.slice.call(dots.children);
    btns.forEach(function(b){
      b.addEventListener('click',function(){
        var s=slides[parseInt(b.dataset.i,10)];
        track.scrollTo({left:s.offsetLeft-track.offsetLeft,behavior:'smooth'});
      });
    });
    var ticking=false;
    track.addEventListener('scroll',function(){
      if(ticking)return; ticking=true;
      requestAnimationFrame(function(){
        var mid=track.scrollLeft+track.clientWidth/2;
        var active=0,best=Infinity;
        slides.forEach(function(s,i){
          var c=s.offsetLeft-track.offsetLeft+s.offsetWidth/2;
          var d=Math.abs(c-mid); if(d<best){best=d;active=i;}
        });
        btns.forEach(function(b,i){b.classList.toggle('is-on',i===active);});
        ticking=false;
      });
    });
  }
  function scan(){document.querySelectorAll('[data-asv-car]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
